import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { UserService } from './../../../data/services/user.service';
import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Helper } from 'src/app/shared/helper';
import { environment } from 'src/environments/environment';
import { FORM_VALIDTIONS } from 'src/app/core/constant/constant';
import { settingsModel } from 'src/app/core/models/settings.model';
import { userDetailsModel } from 'src/app/core/models/userDetails.model';

@Component({
  selector: 'app-user-profile-modal',
  templateUrl: './user-profile-modal.component.html',
  styleUrls: ['./user-profile-modal.component.scss'],
})
export class UserProfileModalComponent implements OnDestroy {
  modalRef!: NgbModalRef;
  modalConfig = {
    centered: true,
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg',
  };
  profileObservable!: Subscription;
  profileUpdate!: FormGroup;
  userDetails!: userDetailsModel;
  imageUrl = environment.IMAGE_URL;
  imagefile!: Blob;
  profile_image: any;
  userSettings!: settingsModel;
  FORM_VALIDATION = FORM_VALIDTIONS;

  @ViewChild('template', { static: true }) template!: TemplateRef<any>;

  constructor(
    private modalService: NgbModal,
    private _userService: UserService,
    public _helper: Helper,
    private _fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this._userService._settingsObservable.subscribe((res: any) => {
      this.userSettings = res?.data;
      this.__initForm();
    });
  }

  open() {
    this.profileObservable = this._userService._userdataObservable.subscribe(
      (data) => {
        this._userService.get_user_profile().then((res: any) => {
          this.userDetails = res.user;
          this.profileUpdate.patchValue({
            username: this.userDetails.username,
            phone: this.userDetails.phone,
            phoneCode: this.userDetails.phoneCode,
            email: this.userDetails.email,
          });
          this.profile_image = `${this.imageUrl}/profileImage/${this.userDetails.profileImage}`;
        });
      }
    );
    this.modalRef = this.modalService.open(this.template, this.modalConfig);
  }

  __initForm() {
    this.profileUpdate = this._fb.group({
      username: new FormControl('', [Validators.required]),
      phone: new FormControl('', [
        Validators.required,
        Validators.minLength(Number(this.userSettings?.minPhoneLength)),
        Validators.maxLength(Number(this.userSettings?.maxPhoneLength)),
      ]),
      phoneCode: new FormControl(''),
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(this.FORM_VALIDATION.pattern),
      ]),
      password: new FormControl('', [Validators.minLength(this.FORM_VALIDATION.password_length)]),
    });
  }

  onSelectImageFile(event: any) {
    let files = event.target.files;
    if (files.length === 0) return;
    let mimeType = files[0].type;

    var fileType = this._helper.uploadFile.filter((element: any) => {
      return mimeType == element;
    });

    if (mimeType != fileType) {
      files = [];
      return;
    } else {
      this.imagefile = files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.imagefile);
      reader.onload = (_event) => {
        this.profile_image = reader.result;
      };
    }
  }

  updateProfile() {
    if (this.profileUpdate.invalid) {
      this.profileUpdate.markAllAsTouched();
      return;
    }

    let formData = new FormData();
    formData.set('username', this.profileUpdate.value.username);
    formData.set('phone', this.profileUpdate.value.phone);
    formData.set('email', this.profileUpdate.value.email);
    formData.set('phoneCode', this.profileUpdate.value.phoneCode);

    if (this.profileUpdate.value.password !== '') {
      formData.set('phone', this.profileUpdate.value.email);
    }
    if (this.imagefile) {
      formData.set('profileImage', this.imagefile);
    }

    this._userService.update_user_profile(formData).then((res) => {

    });
  }

  ngOnDestroy(){
    this.profileObservable.unsubscribe();
  }
}
